export default "__VITE_ASSET__BAtb7w$M__"